import React from 'react';
import PropTypes from 'prop-types';

import {
  FileContainer,
  PercentageText,
  Progress,
  ProgressWrapper,
  Text,
  TextWrapper,
  UploadedText,
  Error,
} from './styles';

const UploadFileProgress = (props) => {
  const { file, percent, error } = props;
  const isFinished = percent === 100;

  return (
    <FileContainer>
      <TextWrapper>
        <Text>{file?.name}</Text>
      </TextWrapper>
      {!!percent && !isFinished && (
        <ProgressWrapper>
          <Progress percent={percent} size="tiny" color="blue" />
          <PercentageText>{`${percent}%`}</PercentageText>
        </ProgressWrapper>
      )}
      {
        isFinished && (
          <UploadedText>The file is uploaded!</UploadedText>
        )
      }
      {
        error && (
          <Error>{error}</Error>
        )
      }
    </FileContainer>
  );
};

UploadFileProgress.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  percent: PropTypes.number,
  error: PropTypes.string,
};

UploadFileProgress.defaultProps = {
  percent: 0,
  error: '',
};

export default UploadFileProgress;
